import { render, staticRenderFns } from "./resumeCard.vue?vue&type=template&id=236bcdde&scoped=true&"
import script from "./resumeCard.vue?vue&type=script&lang=js&"
export * from "./resumeCard.vue?vue&type=script&lang=js&"
import style0 from "./resumeCard.vue?vue&type=style&index=0&id=236bcdde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236bcdde",
  null
  
)

export default component.exports